
import Vue from 'vue'
export default Vue.extend({
  name: 'SimpleFeeTable',
  props: {
    priceInfo: Object,
    excludeService: Boolean
  }
})
